angular.module('angus.controllers').controller('tankOverviewController', [
    '$q', '$rootScope', '$scope', 'tankService', 'gridService2', 'gridState', 'subscriberService',
    function ($q, $rootScope, $scope, tankService, gridService2, gridState, subscriberService) {

        $scope.savedSettings = {};
        $scope.containerInformationHeader = {};
        $scope.isSysAdmin = !!$rootScope.user.isSysAdmin;
        $scope.subscriberId = $rootScope.user.subscriberId;
        $scope.handleSubscriberChanged = handleSubscriberChanged;
        $scope.handleCustomerSelected = handleCustomerSelected;
        $scope.handleCustomerInputChanged = handleCustomerInputChanged;

        $scope.handleContainerSelected = handleContainerSelected;

        $scope.isApplyDisabled = isApplyDisabled;
        $scope.areControlsDisabled = areControlsDisabled;
        $scope.runReport = runReport;
        $scope.data = [];
        function loadDropDowns() {
            return $q.when()
                .then(function () {
                    if ($scope.isSysAdmin && !$scope.subscribers) {
                        return loadSubscribers();
                    }
                })
                .then(function () {
                        return loadTankDropDowns($scope.selectedSubscriberId);
                });
        }

        function loadTankDropDowns() {
            /* Nothing to do here. The Type Ahead Component will use the updated CustomerKey to Select the Customer, which then triggers the onCustomerSelected event */
            return $q.when();
        }

        var gridParams = {
            gridOptions: {},
            gridState: gridState($scope.subscriberId, $scope.widgetCode),
            defs: getColDefs(),
            exportOptions: { fileName: 'Tank Management' }
        }

        gridService2.createGrid(gridParams)
            .then(function (grid) {
                grid.setRows(Promise.resolve());

                $scope.grid = grid;
            });

        function getColDefs() {
            var colDefs = [];

            colDefs.push(gridService2.colDef.createDateNG('calendarDate', 'Date', 'calendarDate', { sort: 'desc' }));
            colDefs.push(gridService2.colDef.createNumber('unitsAvailable', 'Available Units', 'unitsAvailable', {}, { decimalPlaces: 0 }));
            colDefs.push(gridService2.colDef.createNumber('changeUnits', 'Change ', 'changeUnits', {}, { decimalPlaces: 0 }));
            colDefs.push(gridService2.colDef.createDateNG('startDate', 'As Of Date', 'startDate', { sort: 'desc', hide: true }));

            return colDefs;
        }
        function isApplyDisabled() {
                /* No Subscriber */
                if ($scope.settings.selectedSubscriber && !$scope.settings.selectedSubscriber.subscriberKey) {
                    return true;
                }

                /* No Customer */
                if (!$scope.settings.customerKey) {
                    return true;
                }

                /* No Container */
                if (!$scope.settings.containerKey) {
                    return true;
                }

                /* No Dates */
                if (!$scope.settings.startDate || !$scope.settings.endDate) {
                    return true;
                }
        }
        function areControlsDisabled() {
            return $scope.areSubscribersLoading;
        }

        function handleSubscriberChanged() {
            /* Handle Tanks Tab */
            clearCustomerData();
        }
        function handleCustomerSelected(newCustomer) {
            if (newCustomer) {
                $scope.settings.customerKey = newCustomer.customerKey;
            }
        }

        function handleCustomerInputChanged() {
            clearCustomerData();
        }
        function handleContainerSelected(newContainer) {
            if (newContainer) {
                $scope.settings.containerKey = newContainer.containerKey;
            }
            loadTankHeaderData();
            runReport();
        }

        function clearCustomerData() {
            $scope.settings.customerKey = null;
            clearContainerData();
        }

        function clearContainerData() {
            $scope.settings.containerKey = null;
            $scope.containerInformationHeader = null;
        }

        function init() {
            /* Default Settings */
            $scope.settings = {};

            //For when this is accessible from widget detail view
            if (!$scope.isSysAdmin) {
                $scope.settings.selectedSubscriber = {externalSubscriberId:$rootScope.user.subscriberId,
                    subscriberKey:$rootScope.user.subscriberAbosKey};
            }

            /* Default Dates */
            const today = new Date();

            $scope.settings.startDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
            $scope.settings.endDate = new Date(today);

            loadDropDowns()
                .then(function () {
                });
        }

        function loadSubscribers() {
            $scope.areSubscribersLoading = true;

            return subscriberService.getAllLive()
                .then(function (subscribers) {
                    $scope.subscribers = subscribers;
                    $scope.areSubscribersLoading = false;
                });
        }
        function loadTankHeaderData() {
            const settings = $scope.settings;
            const subscriberKey = settings.selectedSubscriber.subscriberKey;
            const containerKey = [$scope.settings.containerKey];

            tankService.getContainers(subscriberKey,containerKey)
                .then(function (data) {
                    $scope.containerInformationHeader = data[0];
                });
        }

        function runReport() {
            const settings = $scope.settings;
            const subscriberKey = settings.selectedSubscriber.subscriberKey;
            var containerKey, startDate, endDate;

                containerKey = settings.containerKey;
                startDate = settings.startDate;
                endDate = settings.endDate;

            var rowPromise = tankService.getHistoricalUnitsAvailable(subscriberKey,containerKey, {startDate,endDate})
                .then(function (data) {
                    $scope.data = data;
                    return data;
                });

            var promise = $scope.grid.setRows(rowPromise);

            return promise;
        }

        init();
    }
]);